var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import classNames from "classnames";
export var TipoBotao;
(function (TipoBotao) {
    TipoBotao["primary"] = "primary";
    TipoBotao["secondary"] = "secondary";
    TipoBotao["success"] = "success";
    TipoBotao["danger"] = "danger";
    TipoBotao["warning"] = "warning";
    TipoBotao["info"] = "info";
    TipoBotao["light"] = "light";
    TipoBotao["dark"] = "dark";
    TipoBotao["link"] = "link";
})(TipoBotao || (TipoBotao = {}));
export var TamanhoBotao;
(function (TamanhoBotao) {
    TamanhoBotao["grande"] = "btn-lg";
    TamanhoBotao["normal"] = "btn-md";
    TamanhoBotao["pequeno"] = "btn-sm";
    TamanhoBotao["mini"] = "btn-xs";
})(TamanhoBotao || (TamanhoBotao = {}));
var Botao = /** @class */ (function (_super) {
    __extends(Botao, _super);
    function Botao(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        if (!this.props.usaLoading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setState({ carregando: true })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.props.onClick()];
                    case 3:
                        _a.sent();
                        if (!this.props.usaLoading) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.setState({ carregando: false })];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            carregando: false
        };
        return _this;
    }
    Botao.prototype.render = function () {
        var _a, _b;
        var type = this.props.submit ? "submit" : "button";
        var classes = classNames("btn", (_a = {}, _a["btn-" + this.props.tipo] = !this.props.outline, _a), (_b = {}, _b["btn-outline-" + this.props.tipo] = this.props.outline, _b), { "btn-block": this.props.block }, this.props.tamanho, this.props.className);
        var classesIcone = classNames("fas", { "mr-2": this.props.titulo && !this.props.iconeDireita }, { "ml-2": this.props.titulo && this.props.iconeDireita }, this.props.icone);
        return (React.createElement("button", { type: type, className: classes, onClick: this.onClick, style: this.props.style, disabled: this.props.desativado || this.state.carregando },
            !this.state.carregando &&
                React.createElement("span", null,
                    this.props.icone && !this.props.iconeDireita && React.createElement("i", { className: classesIcone }),
                    this.props.titulo,
                    this.props.icone && this.props.iconeDireita && React.createElement("i", { className: classesIcone })),
            !this.props.titulo && this.state.carregando &&
                this.props.children,
            this.state.carregando &&
                React.createElement("i", { className: "fas fa-spinner fa-pulse" })));
    };
    Botao.defaultProps = {
        tipo: TipoBotao.primary,
        tamanho: TamanhoBotao.normal,
    };
    return Botao;
}(React.Component));
export { Botao };
